<template>
  <div style="zoom:0.8;">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("screen", 1) }}
      </div>
      <router-link class="btn-blue" to="screens"
        >{{ $tc("screen", 1) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="col-12">
        <div class="row">
          <!-- CINEMAS SELECTION -->
          <div
            class="row new-border back rounded-10 mx-1 mb-2 pt-4"
            style="height: auto"
          >
            <div
              v-for="(item, index) in Screens"
              :key="index"
              v-if="
                item.fieldname !== 'screen_id' &&
                  item.fieldname !== 'screen_is_active'
              "
              class="col-md-3 mb-3"
            >
              <div
                v-if="
                  item.type !== 'radio' &&
                    item.type !== 'dropdown' &&
                    item.type !== 'file' &&
                    item.fieldname !== 'min_seats'
                "
              >
                <div class="d-flex justify-content-center align-items-center">
                  <div class="input-material">
                    <input
                      @focus="onFocusHandler"
                      :type="item.type"
                      :name="item.fieldname"
                      :id="item.fieldname"
                      v-validate="item.validation"
                      v-model="item.fieldvalue"
                      placeholder="."
                      @change="onInputFieldChange($event, item)"
                    />
                    <label>{{ $tc(item.label, 1) }}</label>
                  </div>
                  <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has(item.fieldname)">{{
                    errors.first(`${item.fieldname}`)
                  }}</span>
                </p>
              </div>

              <div
                v-if="
                  item.fieldname == 'min_seats' && getMyCinemaStatusNew() == 'Y'
                "
              >
                <div class="d-flex justify-content-center align-items-center">
                  <div class="input-material">
                    <input
                      @focus="onFocusHandler"
                      :type="item.type"
                      :name="item.fieldname"
                      :id="item.fieldname"
                      v-validate="item.validation"
                      v-model="item.fieldvalue"
                      placeholder="."
                    />
                    <label>{{ $tc(item.label, 1) }}</label>
                  </div>
                  <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has(item.fieldname)">{{
                    errors.first(`${item.fieldname}`)
                  }}</span>
                </p>
              </div>

              <div v-if="item.type === 'dropdown'">
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'cinema_id'"
                >
                  <label
                    :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <div class="d-flex justify-content-center align-items-center">
                    <b-dropdown
                      :disabled="isRoleID"
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Cinema"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCinema()"
                          v-on:keydown="onSearchCinema()"
                          v-on:search="onSearchCinema()"
                          v-model="searchCinema"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in Cinemas"
                        :key="dropdownIndex"
                        href="#"
                        name="selectcine"
                        id="selectcine"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        >{{ dropdownItem.cine_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message">
                    <span
                      v-if="submitted && item.dropdownSelected.length == 0"
                      >{{ msgcinema }}</span
                    >
                  </p>
                </div>

                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'screen_type_id'"
                >
                  <label
                    :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <div class="d-flex justify-content-center align-items-center">
                    <b-dropdown
                      :disabled="isRoleID"
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Screen Type"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchScreenType()"
                          v-on:keydown="onSearchScreenType()"
                          v-on:search="onSearchScreenType()"
                          v-model="searchScreenType"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in screenTypesList"
                        :key="dropdownIndex"
                        href="#"
                        name="select_screen_type"
                        id="select_screen_type"
                        @click="
                          onDropdownChange(
                            $event,
                            'screentype',
                            dropdownItem,
                            index
                          )
                        "
                        >{{ dropdownItem.screen_type_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message"></p>
                </div>

                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'screen_video_format_id'"
                >
                  <label
                    :class="
                      multiSelectedFormatsList &&
                      multiSelectedFormatsList.length > 0
                        ? 'shift-up'
                        : ''
                    "
                    >{{ $tc(item.label, 1) }}</label
                  >

                  <div class="d-flex justify-content-center align-items-center">
                    <!-- <b-dropdown
                    :text="item.dropdownSelected"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search Format"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchFormat()"
                        v-on:keydown="onSearchFormat()"
                        v-model="searchFormat"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in formatList"
                      :key="dropdownIndex"
                      href="#"
                      name="selectfor"
                      id="selectfor"
                      @click="
                        onDropdownChange(
                          $event,
                          item.label,
                          dropdownItem,
                          index
                        )
                      "
                      >{{ dropdownItem.mf_name }}</b-dropdown-item
                    >
                  </b-dropdown> -->
                    <custommultiselect
                      v-model="multiSelectedFormatsList"
                      :options="formatList"
                      :placeholder="$tc('format', 1)"
                      label="mf_name"
                      isSingleId="mf_id"
                      :multiple="true"
                      :closeOnSelect="false"
                      track-by="mf_id"
                    />
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <!-- <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                        (!multiSelectedFormatsList ||
                          multiSelectedFormatsList.length == 0)
                    "
                    >{{ msgformat }}</span
                  >
                </p> -->

                  <!-- <multiselect
                  :options="formatList"
                  v-model="item.dropdownSelected"
                  placeholder="Select Movie Format"
                  label="mf_name"
                  track-by="mf_id"
                  :multiple="true"
                ></multiselect>
                <p
                  v-if="submitted && item.dropdownSelected.length <= 0"
                  class="error_message"
                >Please Select Options.</p>-->
                  <p class="error_message"></p>
                </div>

                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'screen_audio_format_id'"
                >
                  <label
                    :class="
                      multiSelectedSoundTypeList &&
                      multiSelectedSoundTypeList.length > 0
                        ? 'shift-up'
                        : ''
                    "
                    >{{ $tc(item.label, 1) }}</label
                  >

                  <div class="d-flex justify-content-center align-items-center">
                    <custommultiselect
                      v-model="multiSelectedSoundTypeList"
                      :options="soundsList"
                      :placeholder="$tc('sound', 1)"
                      label="sound_format_name"
                      isSingleId="sound_format_id"
                      :multiple="true"
                      :closeOnSelect="false"
                      track-by="sound_format_id"
                    />
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message"></p>
                </div>

                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'screen_size_format'"
                >
                  <label
                    :class="selectedScreenSizeFormat != '' ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >

                  <div class="d-flex justify-content-center align-items-center">
                    <custommultiselect
                      v-model="selectedScreenSizeFormat"
                      :options="ScreenSizeFormats"
                      label="ssf_name"
                      :multiple="false"
                      track-by="ssf_id"
                    />
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message"></p>
                </div>
              </div>

              <div
                v-if="
                  item.type === 'file' && item.fieldname === 'screen_image_url'
                "
              >
                <div class="d-flex align-items-center">
                  <label :for="item.fieldname" class="file-selector w-100">
                    <label
                      class="file-selector-label"
                      :class="
                        item.fieldvalue && item.fieldvalue.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <span class="text-truncate">{{ item.fieldvalue }}</span>
                    <input
                      :type="item.type"
                      :name="item.fieldname"
                      :id="item.fieldname"
                      placeholder="."
                      class="d-none"
                      v-on:change="setImage($event, index, 'screen')"
                    />
                  </label>
                  <div class="col-2 align-self-center">
                    <img
                      width="40"
                      height="40"
                      class="rounded"
                      @click="showImage('Screen Image', index)"
                      :src="_GetImagePath(item.fieldvalue)"
                      v-if="item.fieldvalue && item.fieldvalue.length > 0"
                    />
                    <img
                      v-else
                      width="35"
                      height="35"
                      class="rounded"
                      alt="Empty Image"
                      src="@/assets/img/icons/empty-image.svg"
                    />
                  </div>
                  <!-- <img
                    src="@/assets/img/icons/question.svg"
                    class="ml-2"
                    height="20"
                    width="20"
                    v-b-tooltip.hover
                    :title="$t(item.tooltip)"
                  /> -->
                </div>
                <p class="error_message"></p>
              </div>
            </div>

            <!-- LEAD TIME HH-->
            <div class="col-md-2 mb-3" v-if="getMyCinemaStatusNew() == 'Y'">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="leadTimeHH"
                    type="text"
                    name="leadTimeHH"
                    id="leadTimeHH"
                    v-validate="'numeric'"
                    @input="onChangeLeadTime($event, 'HH')"
                  />
                  <label>Lead Time (HH)</label>
                </div>
                <!-- <Tooltip :title="'Lead Time in HH'" /> -->
              </div>
              <p
                v-if="submitted && errors.has('leadTimeHH')"
                class="error_message"
              >
                {{ errors.first("leadTimeHH") }}
              </p>
            </div>
            <!-- LEAD TIME MM-->
            <div class="col-md-2 mb-3" v-if="getMyCinemaStatusNew() == 'Y'">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="leadTimeMM"
                    type="text"
                    name="leadTimeMM"
                    id="leadTimeMM"
                    maxlength="2"
                    v-validate="'numeric'"
                    @input="onChangeLeadTime($event, 'MM')"
                  />
                  <label>Lead Time (MM)</label>
                </div>
                <!-- <Tooltip :title="'Lead Time MM'" /> -->
              </div>
              <p
                v-if="submitted && errors.has('leadTimeMM')"
                class="error_message"
              >
                {{ errors.first("leadTimeMM") }}
              </p>
            </div>

            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="d-flex align-items-center">
                <b-form-radio :value="1" class="j-radio" v-model="validityType">
                  <div>
                    <span>{{ "Valid From" }}</span>
                  </div>
                </b-form-radio>
                <strong class="mx-3">OR</strong>

                <b-form-radio :value="2" class="j-radio" v-model="validityType">
                  <div>
                    <span>{{ "Valid Till" }}</span>
                  </div>
                </b-form-radio>
              </div>
            </div>

            <div class="col-md-2 mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="validityDate"
                    v-on:click="validityDate = null"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="validityDate"
                  ></Datepicker>
                  <label :class="validityDate ? 'active' : ''">
                    Validity Date
                  </label>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="has_seat_delivery"
                  value="Y"
                  unchecked-value="N"
                  class="j-checkbox"
                >
                  Has Seat Delivery
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div
            v-if="getMyCinemaStatusNew() == 'Y'"
            class="col-12 mb-2 new-border back rounded-10 pt-2"
          >
            <div class="row">
              <label class="col-2 mb-2"> Show Type </label>
              <div
                class="col-3 mb-2 d-flex justify-content-start align-items-center"
                v-for="(item, index_s) in ShowTypeArray"
                :key="index_s + item.screening_name"
              >
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  v-model="item.value"
                  style="height: 20px; width: 20px; margin-right: 5px"
                />
                <span class="switch-slider"> {{ item.screening_name }}</span>
              </div>
            </div>
          </div>
          <div
            class="col-12 mb-4"
            v-for="(screenseat, screenseatIndex) in ScreenSeatDetail"
            :key="screenseatIndex + screenseat"
          >
            <div class="row mx-0 px-0 pb-0 new-border back rounded-10 pt-4">
              <div class="col-11">
                <div class="row">
                  <div class="col-10">
                    <div class="row">
                      <div class="col-4 mb-4" v-if="false">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div class="input-material">
                            <input
                              type="text"
                              v-model="screenseat.seattype"
                              name="seattype"
                              id="seattype"
                              v-validate="'required'"
                              placeholder="."
                            />
                            <label
                              >{{ $tc("seat", 2) }} {{ $tc("type", 1) }}</label
                            >
                          </div>
                          <!-- <Tooltip :title="$t('seatType_SeatsTypes')" /> -->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('seattype')">{{
                            errors.first("seattype")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-4 mb-4">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-curve-container">
                            <label
                              :class="screenseat.sstg_id ? 'shift-up' : ''"
                              >{{ "Screen Seat Type" }}</label
                            >
                            <multiselect
                              :options="screenSeatTypeGroup"
                              v-model="screenseat.selected_sst_group"
                              :searchable="true"
                              label="sstg_name"
                              track-by="sstg_id"
                              placeholder=""
                              @select="
                                onSelectScreenSeatTypeGroup(
                                  $event,
                                  screenseatIndex,
                                  'ADD'
                                )
                              "
                              @remove="
                                onSelectScreenSeatTypeGroup(
                                  $event,
                                  screenseatIndex,
                                  'REMOVE'
                                )
                              "
                            ></multiselect>
                          </div>
                        </div>
                      </div>

                      <div class="col-4 mb-4">
                        <div class="d-flex">
                          <label class="shift-name-label bg-white border"
                            >{{ $tc("seat", 1) }} Color {{ $t("code") }}</label
                          >
                          <label class="select-color ml-2">
                            <input
                              type="color"
                              v-model="screenseat.seatcolor"
                              @change="selectedColor($event)"
                              id="selectColor"
                            />
                            <!-- v-model="seatTypes.sst_seat_color_code" -->
                          </label>
                        </div>
                      </div>

                      <div class="col-4 mb-4">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div class="input-material">
                            <!-- v-model="seatTypes.sst_no_of_seats" -->
                            <input
                              type="text"
                              v-model="screenseat.noofseats"
                              step="any"
                              name="seatno"
                              id="seatno"
                              v-validate="'required|numeric'"
                              placeholder="."
                              @keyup="
                                CalculateSelectedNoOfSeats($event.target.value)
                              "
                            />
                            <label>{{ $t("noofseats") }}</label>
                          </div>
                          <!-- <Tooltip :title="$t('seatTypeSeatno_tooltip')" /> -->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('seatno')">{{
                            errors.first("seatno")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-4 mb-4">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div class="input-material">
                            <!-- v-model="seatTypes.sst_no_of_seats" -->
                            <input
                              type="text"
                              v-model="screenseat.order"
                              step="any"
                              name="order"
                              id="order"
                              v-validate="'required|numeric'"
                              placeholder="."
                            />
                            <label>{{ $t("seatorder") }}</label>
                          </div>
                          <!-- <Tooltip :title="$t('seatTypeSeatno_tooltip')" /> -->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('order')">{{
                            errors.first("order")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-4 mb-4">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div class="input-material">
                            <label class="material-file-upload">
                              <input
                                type="file"
                                accept="image/*"
                                v-on:change="
                                  setImage($event, screenseatIndex, 'seattype')
                                "
                                name="image"
                                :id="'image' + screenseatIndex"
                              />
                              <div
                                class="label"
                                v-bind:class="{
                                  'shift-up':
                                    screenseat.screen_seat_type_url &&
                                    screenseat.screen_seat_type_url.length > 0
                                }"
                              >
                                <div class="text-truncate">Upload Image</div>
                              </div>
                              <div class="uploaded-file-name">
                                <div class="text-truncate pt-2">
                                  {{ screenseat.screen_seat_type_url }}
                                </div>
                              </div>
                            </label>
                          </div>
                          <!-- <div class="col-2 align-self-center">
                            <img
                              width="40"
                              height="40"
                              class="rounded"
                              @click="showImage('Seat Image', screenseatIndex)"
                              :src="_GetImagePath(screenseat.screen_seat_type_url)"
                              v-if="screenseat.screen_seat_type_url && screenseat.screen_seat_type_url.length > 0"
                            />
                            <img
                              v-else
                              width="35"
                              height="35"
                              class="rounded"
                              alt="Empty Image"
                              src="@/assets/img/icons/empty-image.svg"
                            />
                          </div> -->
                          <!-- <Tooltip :title="$t('seatTypeSeatimage_tooltip')" /> -->
                        </div>
                      </div>

                      <div class="col-4 mb-4">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div class="input-material">
                            <input
                              type="text"
                              v-model="screenseat.entry_id"
                              step="any"
                              name="entry_id"
                              id="entry_id"
                              v-validate="'required'"
                              placeholder="."
                            />
                            <label>{{ $t("entry_id") }}</label>
                          </div>
                          <!-- <Tooltip :title="$t('entry_id_tooltip')" /> -->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && !screenseat.entry_id">{{
                            errors.first("entry_id")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-4 mb-4">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div class="input-material">
                            <input
                              type="text"
                              v-model="screenseat.entry_description"
                              step="any"
                              name="entry_description"
                              id="entry_description"
                              v-validate=""
                              placeholder="."
                            />
                            <label>{{ $t("entry_description") }}</label>
                          </div>
                          <!-- <Tooltip :title="$t('entry_description_tooltip')" /> -->
                        </div>
                        <p class="entry_description">
                          <span
                            v-if="submitted && errors.has('entry_description')"
                            >{{ errors.first("entry_description") }}</span
                          >
                        </p>
                      </div>

                      <div class="col-4 mb-2">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div class="input-material">
                            <input
                              type="text"
                              v-model="screenseat.screentype_description"
                              step="any"
                              name="screentype_description"
                              id="screentype_description"
                              v-validate=""
                              placeholder="."
                              v-b-tooltip.hover
                              :title="$t('screentype_description_tooltip')"
                            />
                            <label>{{ $t("screentype_description") }}</label>
                          </div>
                          <!--Tooltip :title="$t('entry_description_tooltip')" /-->
                        </div>
                        <p class="entry_description">
                          <span
                            v-if="
                              submitted && errors.has('screentype_description')
                            "
                            >{{ errors.first("screentype_description") }}</span
                          >
                        </p>
                      </div>
                      <!-- <div class="col-4 mb-4">
                         <div class="d-flex align-items-center">
                      <label class="mr-4 mb-0">{{ $t("active") }}</label>
                      <b-form-checkbox
                        unchecked-value="N"
                        v-model="screenseat.isActive"
                        value="Y"
                        switch
                      ></b-form-checkbox>
                    </div>
                      </div> -->
                    </div>
                  </div>

                  <div class="col-2 align-self-center">
                    <div
                      v-if="screenseat.entry_id"
                      class="d-flex justify-content-center align-items-center"
                    >
                      <qr-code
                        :text="String(screenseat.entry_id)"
                        :size="115"
                        error-level="H"
                      ></qr-code>
                    </div>
                    <div
                      v-else
                      class="qrcode-border-box d-flex justify-content-center align-items-center"
                    >
                      <div
                        class="d-flex justify-content-center align-items-center text-muted"
                      >
                        QR code
                      </div>
                    </div>
                    <!-- <div class="d-flex align-items-center">
                      <label class="mr-4 mb-0">{{ $t("active") }}</label>
                      <b-form-checkbox
                        unchecked-value="N"
                        v-model="screenseat.isActive"
                        value="Y"
                        switch
                      ></b-form-checkbox>
                    </div> -->
                  </div>
                  <div
                    class="col-12 mb-4"
                    v-for="(singleRatecard,
                    singleRatecardIndex) in screenseat.rateCards"
                    :key="singleRatecardIndex"
                  >
                    <div
                      class="row mx-0 rounded-10 pt-4 screen-inner pb-4"
                      style="padding: 0px"
                    >
                      <div class="col-lg-6 col-xl-2 mb-4">
                        <div class="input-material">
                          <div class="add-datepicker">
                            <!-- <datetime
                              v-model="singleRatecard.start_date_time"
                              type="time"
                              class="theme-custom-date-time"
                              format="hh:mm:ss a"
                              use12-hour
                            ></datetime> -->
                            <vue-timepicker
                              manual-input
                              v-model="singleRatecard.start_date_time"
                              id="starttime"
                              @change="
                                onChangeStartAndEndTime(
                                  $event,
                                  singleRatecard,
                                  'start_date_time'
                                )
                              "
                            ></vue-timepicker>
                            <!-- <date-picker
                              v-model="singleRatecard.start_date_time"
                              @change="
                                onChangeDateTime(
                                  'start',
                                  $event,
                                  screenseatIndex,
                                  singleRatecardIndex
                                )
                              "
                              lang="en"
                              type="time"
                              format="hh:mm"
                              :minute-step="1"
                              class="time_picker"
                              placeholder="Start Time"
                              name="starttime"
                              id="starttime"
                              v-validate="'required'"
                            /> -->
                            <label class="active">{{ $t("starttime") }}</label>
                          </div>
                        </div>
                        <p class="error_message">
                          <span
                            v-if="submitted && !singleRatecard.start_date_time"
                            >{{ $t("rc_start_time_required") }}</span
                          >
                        </p>
                      </div>

                      <div class="col-lg-6 col-xl-2 mb-4 pl-4">
                        <div class="input-material">
                          <div class="add-datepicker">
                            <!-- <datetime
                              v-model="singleRatecard.end_date_time"
                              type="time"
                              class="theme-custom-date-time"
                              format="hh:mm:ss a"
                              use12-hour
                            ></datetime> -->
                            <vue-timepicker
                              manual-input
                              v-model="singleRatecard.end_date_time"
                              id="endtime"
                              @change="
                                onChangeStartAndEndTime(
                                  $event,
                                  singleRatecard,
                                  'end_date_time'
                                )
                              "
                            ></vue-timepicker>
                            <!-- <date-picker
                              v-model="singleRatecard.end_date_time"
                              @change="
                                onChangeDateTime(
                                  'end',
                                  $event,
                                  screenseatIndex,
                                  singleRatecardIndex
                                )
                              "
                              lang="en"
                              type="time"
                              format="hh:mm"
                              :minute-step="1"
                              class="time_picker"
                              placeholder="End Time"
                              name="endtime"
                              id="endtime"
                              v-validate="'required'"
                            /> -->
                            <label class="active">{{ $t("endtime") }}</label>
                          </div>
                        </div>
                        <p class="error_message">
                          <span
                            v-if="submitted && !singleRatecard.end_date_time"
                            >{{ $t("rc_end_time_required") }}</span
                          >
                        </p>
                      </div>

                      <div class="col-lg-6 col-xl-3 mb-4 pl-5">
                        <b-dropdown
                          class="w-100"
                          variant="dropdown-curve"
                          :text="singleRatecard.rc_name"
                        >
                          <div class="px-2 pb-2">
                            <input
                              required
                              autofocus
                              type="search"
                              placeholder="Search Rate Card Group"
                              class="form-control form-control-sm"
                              v-on:keyup="onSearchRateCard()"
                              v-on:keydown="onSearchRateCard()"
                              v-on:search="onSearchRateCard()"
                              v-model="searchRateCard"
                            />
                          </div>
                          <b-dropdown-item
                            v-for="(Ratecard, RatecardIndex) in RatecardsList"
                            :key="RatecardIndex"
                            v-on:click="
                              onSelectRateCard(
                                screenseatIndex,
                                singleRatecardIndex,
                                Ratecard
                              )
                            "
                            >{{ Ratecard.rc_g_name }}</b-dropdown-item
                          >
                        </b-dropdown>
                        <p class="error_message">
                          <span
                            v-if="submitted && !singleRatecard.rate_card_id"
                            >{{ $t("selectratecard") }}</span
                          >
                        </p>
                      </div>

                      <div
                        v-if="isPrivateEnabled"
                        class="col-lg-6 col-xl-3 mb-4 pl-5"
                      >
                        <b-dropdown
                          class="w-100"
                          variant="dropdown-curve"
                          :text="singleRatecard.rcp_name"
                        >
                          <div class="px-2 pb-2">
                            <input
                              required
                              autofocus
                              type="search"
                              placeholder="Search Rate Card Group Beta"
                              class="form-control form-control-sm"
                              v-on:keyup="onSearchPrivateRateCard()"
                              v-on:keydown="onSearchPrivateRateCard()"
                              v-on:search="onSearchPrivateRateCard()"
                              v-model="searchPrivateRateCard"
                            />
                          </div>
                          <b-dropdown-item
                            v-for="(Ratecard,
                            RatecardIndex) in PrivateRatecardsList"
                            :key="RatecardIndex"
                            v-on:click="
                              onSelectRateCardPrivate(
                                screenseatIndex,
                                singleRatecardIndex,
                                Ratecard
                              )
                            "
                            >{{ Ratecard.rc_g_name }}</b-dropdown-item
                          >
                        </b-dropdown>
                        <p class="error_message">
                          <span
                            v-if="
                              submitted && !singleRatecard.rate_card_private_id
                            "
                            >{{ $t("selectprivateratecard") }}</span
                          >
                        </p>
                      </div>

                      <div class="row ml-2">
                        <div class="col-lg-3 col-xl-2">
                          <div>{{ $t("select") }} {{ $t("days") }}:</div>
                        </div>
                        <div class="col-lg-9 col-xl-10 pl-0">
                          <div class="row">
                            <b-form-checkbox
                              v-for="(weekdaysLoop,
                              weekdaysKey) in singleRatecard.weekDays"
                              :key="weekdaysKey"
                              style="min-width: 125px"
                              class="j-checkbox mb-3"
                              @change="
                                onChangeWeekdays(
                                  $event,
                                  weekdaysKey,
                                  screenseatIndex,
                                  singleRatecardIndex,
                                  singleRatecard
                                )
                              "
                              v-model="singleRatecard.weekDays[weekdaysKey]"
                            >
                              <div class="text-capitalize">
                                {{ weekdaysKey }}
                              </div>
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-1 d-flex justify-content-center align-items-center border-left"
                      >
                        <button
                          v-if="singleRatecardIndex === 0"
                          @click.prevent.stop="
                            increaseRateCard(screenseatIndex)
                          "
                          class="btn-transparent"
                        >
                          <img
                            src="@/assets/img/icons/plus.svg"
                            height="35"
                            width="35"
                          />
                        </button>

                        <button
                          v-else
                          @click.prevent.stop="
                            decreaseRatecardIndex(
                              screenseatIndex,
                              singleRatecardIndex
                            )
                          "
                          class="btn-transparent"
                        >
                          <img
                            src="@/assets/img/icons/minus.svg"
                            height="35"
                            width="35"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-4">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            screenseat.selectedMappedRateCards.length > 0
                              ? 'shift-up'
                              : ''
                          "
                          >{{ "Mapped Rate Cards" }}</label
                        >
                        <multiselect
                          :options="RateCardMappingArray"
                          v-model="screenseat.selectedMappedRateCards"
                          :searchable="true"
                          label="rc_g_name"
                          track-by="rc_g_id"
                          placeholder=""
                          :multiple="true"
                          :closeOnSelect="false"
                          group-values="RateCards"
                          group-label="label"
                          :group-select="true"
                        ></multiselect>
                      </div>
                    </div>
                    <!-- <div class="text-truncate fs-12">Note: Default All Rate Cards.</div> -->
                  </div>
                </div>
              </div>
              <!-- {{screenseatIndex}} -->
              <div
                class="col-1 d-flex justify-content-center align-items-center border-left"
              >
                <button
                  v-if="screenseatIndex === 0"
                  @click.prevent.stop="increaseSeatType()"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>

                <button
                  v-else
                  @click.prevent.stop="decreaseSeatType(screenseatIndex)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-12 text-center mt-4">
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="handleSubmit(true)"
            >
              {{ $t("save") }}
            </button>
            <button
              :disabled="btenable"
              @click.prevent.stop="handleSubmit(false)"
              type="submit"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button>
            <button @click.prevent.stop="resetHandler" class="btn-black">
              {{ $t("reset") }}
            </button>
            <b-button class="btn-outline-grey" variant="default" to="screens">{{
              $t("cancel")
            }}</b-button>
          </div>
        </div>
      </form>
    </div>
    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      :title="ImageType"
      id="selected-image-preview-modal"
    >
      <img
        v-if="ImageType == 'Screen Image'"
        :src="_GetImagePath(Screens[11].fieldvalue)"
        class="img-fluid"
      />
      <img
        v-if="ImageType == 'Seat Image'"
        :src="
          _GetImagePath(
            SeatDetails[this.selectedImageIndex].screen_seat_type_url
          )
        "
        class="img-fluid"
      />
    </b-modal>

    <b-modal id="imagecropper" hide-header hide-footer no-close-on-backdrop>
      <label class="h4 text-center">Crop Image</label>
      <button
        class="btn-clearDate float-right"
        v-on:click="hideCropperModal('imagecropper')"
      >
        ✖
      </button>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :aspect-ratio="175 / 175"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <div class="text-center">
        <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Screens from "@/helper/formJSONMaster/Screens";
import CinemasService from "@/services/CinemasService";
import scheduleService from "@/services/scheduleService";
import Multiselect from "vue-multiselect";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import _ from "lodash";
import { generateRandomCode } from "@/helper/collection";

export default {
  components: { Multiselect, VueTimepicker, DatePicker, VueCropper },

  data() {
    return {
      has_seat_delivery: "N",
      validityDate: null,
      validityType: 1,
      screenSeatTypeGroup: [],
      leadTimeHH: "00",
      leadTimeMM: "00",
      CinemasCopy: [],
      searchCinema: "",
      FormatsCopy: [],
      searchFormat: "",
      btenable: false,
      msgcinema: "Please Select Cinema",
      msgformat: "Please Select Video Format",
      audioMsgformat: "Please Select Audio Format",
      screenTypeMsg: "Please Select Screen Type",
      screenSizeFormat: "Please Select Screen Size Format",
      Screens: Screens.screens,
      totalScreens: [],
      submitted: false,
      Methods: Screens.Methods,
      Cinemas: [],
      formatList: [],
      multiSelectedFormatsList: [],
      multiSelectedSoundTypeList: [],
      soundsList: [],
      screenTypesList: [],
      selectedScreenType: undefined,
      total_screen: "",
      isRoleID: true,
      selectedCinema: "",
      RatecardsList: [],
      PrivateRatecardsList: [],
      RateCardListCopy: [],
      RateCardMappingArray: [],
      searchRateCard: "",
      searchScreenType: "",
      screenTypesListCopy: [],
      selectedScreenSizeFormat: "",
      ScreenSizeFormats: [],
      searchPrivateRateCard: "",
      PrivateRatecardsListCopy: [],
      file: "",
      imgSrc: "",
      cropImg: "",
      filename: "",
      indexofthubmnail: "",
      ImageType: "",
      UploadFor: "",
      selectedImageIndex: "",
      ScreenSeatDetail: [
        {
          seattype: "",
          selected_sst_group: "",
          sstg_id: null,
          sstg_name: "",
          seatcolor: "#dc2828",
          noofseats: "",
          entry_id: "",
          unique_entry_id: "",
          entry_description: "",
          screentype_description: "",
          selectedMappedRateCards: [],
          order: "",
          isActive: "Y",
          screen_seat_type_url: "",
          unique_id: Math.round(Math.random() * 10000),
          rateCards: [
            {
              rc_name: "Select Rate Card Group",
              rcp_name: "Rate Card Group Beta",
              start_date_time: "",
              end_date_time: "",
              rate_card_id: "",
              rate_card_private_id: "",
              weekDays: {
                selectAll: true,
                sunday: true,
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true
              }
            }
          ]
        }
      ],
      ShowTypeArray: [
        {
          booking_type_id: "1",
          screening_name: "Confirmed Screening",
          value: false
        },
        {
          booking_type_id: "2",
          screening_name: "CrowdSource Screening",
          value: false
        },
        {
          booking_type_id: "3",
          screening_name: "Private Screening",
          value: false
        }
      ],
      isMyCinema: true,
      selectShowType: "Select Show Type",
      errorCount: 0,
      isPrivateEnabled: true
    };
  },
  beforeMount() {
    this.getGlobalOptions();
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }
    this.getFormatList();
    this.getScreenTypesList();
    this.getScreenSeatTypeGroupsList();
    this.getAudioFormatList();
    this.getScreenSizeFormat();
  },

  mounted() {
    this.resetHandler();
    // window.addEventListener("change", this.selectedColor);
  },

  methods: {
    onChangeLeadTime(event, type) {
      let time = event.target.value;

      if (type === "HH") {
        this.leadTimeHH = time;
      } else if (type === "MM") {
        this.leadTimeMM = time;
      }
    },
    getScreenSeatTypeGroupsList() {
      let payload = {
        tableName: "ms_screen_seat_type_group",
        sstg_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.screenSeatTypeGroup = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    onSelectScreenSeatTypeGroup(event, index, type) {
      if (type == "ADD") {
        this.ScreenSeatDetail[index].sstg_id = event.sstg_id;
        this.ScreenSeatDetail[index].sstg_name = event.sstg_name;
        this.ScreenSeatDetail[index].seattype = event.sstg_name;
      } else if (type == "REMOVE") {
        this.ScreenSeatDetail[index].sstg_id = null;
        this.ScreenSeatDetail[index].sstg_name = "";
        this.ScreenSeatDetail[index].seattype = "";
      }
    },
    saveShowType(item, screenMainIndex) {},
    showImage: function(type, index) {
      this.ImageType = type;
      this.selectedImageIndex = index;
      this.$refs["preview-modal"].show();
    },
    hideCropperModal: function(modal) {
      this.$bvModal.hide("imagecropper");
    },
    setImage: function(e, index, uploadtype) {
      this.file = e.target.files[0];
      this.filename = e.target.files[0]["name"];
      this.indexofthubmnail = index;
      this.UploadFor = uploadtype;
      if (this.file.type.indexOf("image/") === -1) {
        this.$toasted.show("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          this.$bvModal.show("imagecropper");
          e.target.value = "";
        };
        reader.readAsDataURL(this.file);
      } else {
        // alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      this.$bvModal.hide("imagecropper");
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
    },

    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    onThumbnailUpload: function(image, filename, index) {
      let loader = this.$loading.show();

      let formData = new FormData();
      // formData.append("image", image);
      formData.append("image", image, filename);
      formData.append("imagePath", "Cinema Image");
      MasterService.GlobalUploadImage(formData)
        .then(response => {
          // console.log("response :", response);
          const { data } = response;
          if (data && data.status) {
            if (this.UploadFor == "seattype") {
              this.ScreenSeatDetail[index].screen_seat_type_url = data.path;
            } else {
              this.Screens[index].fieldvalue = data.path;
            }
            this.imgSrc = "";
            this.$bvModal.hide("imagecropper");
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    selectedColor: async function(e) {
      const hexToRgb = hex =>
        hex
          .replace(
            /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
            (m, r, g, b) => "#" + r + r + g + g + b + b
          )
          .substring(1)
          .match(/.{2}/g)
          .map(x => parseInt(x, 16));

      var rgb = await hexToRgb(e.target.value);

      if ((rgb[1] > 200 && rgb[0] < 150) || (rgb[1] > 200 && rgb[2] < 150)) {
        e.target.value = "#dc2828";
        this.$toasted.show("Green and lighter colors is not available.");
      }
    },
    onChangeDateTime(type, event, screen_index, rate_card_index) {
      if (type === "end") {
        this.ScreenSeatDetail[screen_index].rateCards[
          rate_card_index
        ].end_date_time = event;
      } else if (type === "start") {
        this.ScreenSeatDetail[screen_index].rateCards[
          rate_card_index
        ].start_date_time = moment(event).format("hh:mm");
      }
    },
    CalculateSelectedNoOfSeats: function() {
      let countSeats = 0;

      this.ScreenSeatDetail.map(x => {
        countSeats += parseInt(x.noofseats);
      });

      if (countSeats > this.Screens[6].fieldvalue) {
        this.$toasted.show(
          "No of seats of seat type is greater than total No of seats."
        );
      }
    },
    onSearchRateCard() {
      if (this.searchRateCard && this.searchRateCard.length > 0) {
        this.RatecardsList = this.RateCardListCopy.filter(x => {
          if (
            // TODO Enter Rate card variable name
            x.rc_g_name
              .toLowerCase()
              .includes(this.searchRateCard.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.RatecardsList = this.RateCardListCopy;
      }
    },
    onSearchPrivateRateCard() {
      if (this.searchPrivateRateCard && this.searchPrivateRateCard.length > 0) {
        this.PrivateRatecardsList = this.PrivateRatecardsListCopy.filter(x => {
          if (
            // TODO Enter Rate card variable name
            x.rc_g_name
              .toLowerCase()
              .includes(this.searchPrivateRateCard.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.PrivateRatecardsList = this.PrivateRatecardsListCopy;
      }
    },
    onSearchFormat() {
      if (this.searchFormat && this.searchFormat.length > 0) {
        this.formatList = this.FormatsCopy.filter(x => {
          if (
            x.mf_name.toLowerCase().includes(this.searchFormat.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.formatList = this.FormatsCopy;
      }
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchScreenType: function() {
      if (this.searchScreenType && this.searchScreenType.length > 0) {
        this.screenTypesList = this.screenTypesListCopy.filter(x => {
          if (
            x.screen_type_name
              .toLowerCase()
              .includes(this.searchScreenType.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.screenTypesList = this.screenTypesListCopy;
      }
    },
    increaseSeatType: function() {
      let rateCards = [
        {
          rc_name: "Select Rate Card Group",
          rcp_name: "Rate Card Group Beta",
          start_date_time: "",
          end_date_time: "",
          rate_card_id: "",
          rate_card_private_id: "",
          unique_id: Math.round(Math.random() * 10000),
          weekDays: {
            selectAll: true,
            sunday: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true
          }
        }
      ];

      if (this.ScreenSeatDetail && this.ScreenSeatDetail.length > 0) {
        console.log("coming to this if codition when adding screen type");
        rateCards = _.cloneDeep(this.ScreenSeatDetail[0].rateCards);
        rateCards = rateCards.map(x => ({
          ...x,
          rc_name: "Select Rate Card Group",
          rcp_name: "Rate Card Group Beta"
        }));
      }

      this.ScreenSeatDetail.push({
        seattype: "",
        selected_sst_group: "",
        sstg_id: null,
        sstg_name: "",
        seatcolor: "#dc2828",
        entry_id: "",
        entry_description: "",
        unique_entry_id: "",
        noofseats: "",
        order: "",
        isActive: "Y",
        screen_seat_type_url: "",
        selectedMappedRateCards: [],
        rateCards: rateCards,
        screentype_description: ""
      });
    },
    onChangeStartAndEndTime: function(
      eventData,
      singleRateCard,
      type = "start_date_time"
    ) {
      let unique_id = singleRateCard.unique_id;
      this.ScreenSeatDetail[screenseatIndex].rateCards[singleRatecardIndex][
        type
      ] = eventData.displayTime;
      // for (let seatType of this.ScreenSeatDetail) {
      //   let rateCard = seatType.rateCards.find(
      //     (x) => x.unique_id === unique_id
      //   );
      //   if (rateCard) {
      //     rateCard[type] = eventData.displayTime;
      //   }
      // }
    },
    decreaseSeatType(index) {
      this.ScreenSeatDetail.splice(index, 1);
    },
    onFocusHandler: function() {},
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      let body = {
        activekey: "cine_is_active"
      };
      // MasterService.GetActiveList(payload)
      CinemasService.GetActiveCinemas(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                this.Screens.map(y => {
                  if (this.Screens[1].fieldkey == "cinema") {
                    this.Screens[1].dropdownSelected = x.cine_name;
                  }
                });
                // this.cinema_id = cine_id;
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    getScreenSizeFormat() {
      MasterService.GetScreenSizeFormat()
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.ScreenSizeFormats = data.Records;
            console.log("FORMATS", this.ScreenSizeFormats);
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    getScreenTypesList: function(cine_id) {
      MasterService.GetScreenTypes()
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.screenTypesList = data.Records;
            this.screenTypesListCopy = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    getFormatList: function() {
      let payload = {
        tableName: "ms_movie_formats"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.FormatsCopy = data.Records;
            this.formatList = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    getAudioFormatList: function() {
      let payload = {
        tableName: "ms_sound_formats"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.soundsList = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    // onDropdownChange: function(value) {
    //    // this.selectedCinema = item.cine_name;
    //   this.getScreensList(value);
    // },
    onChangeWeekdays: function(
      event,
      keyname,
      screenseatIndex,
      singleRatecardIndex,
      singleRatecard
    ) {
      let unique_id = singleRatecard.unique_id;
      if (
        this.ScreenSeatDetail[screenseatIndex].rateCards[singleRatecardIndex]
      ) {
        if (keyname !== "selectAll") {
          this.ScreenSeatDetail[screenseatIndex].rateCards[
            singleRatecardIndex
          ].weekDays["selectAll"] = false;
        }

        let len = Object.keys(
          this.ScreenSeatDetail[screenseatIndex].rateCards[singleRatecardIndex]
            .weekDays
        ).length;
        if (keyname === "selectAll" && event) {
          this.ScreenSeatDetail[screenseatIndex].rateCards[
            singleRatecardIndex
          ].weekDays["selectAll"] = true;
          Object.keys(
            this.ScreenSeatDetail[screenseatIndex].rateCards[
              singleRatecardIndex
            ].weekDays
          ).map(x => {
            x !== "selectAll"
              ? (this.ScreenSeatDetail[screenseatIndex].rateCards[
                  singleRatecardIndex
                ].weekDays[x] = true)
              : "";
          });
        } else if (keyname === "selectAll" && !event) {
          this.ScreenSeatDetail[screenseatIndex].rateCards[
            singleRatecardIndex
          ].weekDays["selectAll"] = false;
          Object.keys(
            this.ScreenSeatDetail[screenseatIndex].rateCards[
              singleRatecardIndex
            ].weekDays
          ).map(x => {
            x !== "selectAll"
              ? (this.ScreenSeatDetail[screenseatIndex].rateCards[
                  singleRatecardIndex
                ].weekDays[x] = false)
              : "";
          });
        } else if (keyname !== "selectAll") {
          this.ScreenSeatDetail[screenseatIndex].rateCards[
            singleRatecardIndex
          ].weekDays[keyname] = event;

          if (
            this.ScreenSeatDetail[screenseatIndex].rateCards[
              singleRatecardIndex
            ].weekDays.selectAll
          ) {
            this.ScreenSeatDetail[screenseatIndex].rateCards[
              singleRatecardIndex
            ].weekDays["selectAll"] = false;
          }
        }
      }
      // for (let seatType of this.ScreenSeatDetail) {
      //   let rateCard = seatType.rateCards.find(
      //     (x) => x.unique_id === unique_id
      //   );

      //   if (rateCard) {
      //     if (keyname !== "selectAll") {
      //       rateCard.weekDays["selectAll"] = false;
      //     }

      //     let len = Object.keys(rateCard.weekDays).length;
      //     if (keyname === "selectAll" && event) {
      //       rateCard.weekDays["selectAll"] = true;
      //       Object.keys(rateCard.weekDays).map((x) => {
      //         x !== "selectAll" ? (rateCard.weekDays[x] = true) : "";
      //       });
      //     } else if (keyname === "selectAll" && !event) {
      //       rateCard.weekDays["selectAll"] = false;
      //       Object.keys(rateCard.weekDays).map((x) => {
      //         x !== "selectAll" ? (rateCard.weekDays[x] = false) : "";
      //       });
      //     } else if (keyname !== "selectAll") {
      //       rateCard.weekDays[keyname] = event;

      //       if (rateCard.weekDays.selectAll) {
      //         rateCard.weekDays["selectAll"] = false;
      //       }
      //     }
      //   }
      // }
    },

    getScreensList: function(event, type, item, mainIndex) {
      var cine_screens = item.cine_screens;

      this.totalScreens = [];

      let body = {
        activekey: "screen_is_active",
        conditionColName: "cinema_id",
        conditionId: item.cine_id
      };
      CinemasService.GetActiveScreenByCinema(body)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            console.log("this.Formats :", this.Formats);
            this.totalScreens = data.Records.length;
            var x;
            if (cine_screens > this.totalScreens) {
              this.Screens[mainIndex].fieldvalue = item.cine_id;
              this.Screens[mainIndex].dropdownSelected = item.cine_name;
            } else {
              this.$toasted.show("You have added all screens");
            }
            console.log("this.Screensss :", this.totalScreens);
          } else {
            this.Screens[mainIndex].fieldvalue = item.cine_id;
            this.Screens[mainIndex].dropdownSelected = item.cine_name;
            this.noScreen = true;
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },

    getRatecardsList: function(cinema_id) {
      console.log("getRatecardsList\n", { cinema_id });

      scheduleService
        .GetPrivateRatecardGroupByCinemaId({ cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RatecardsList = data.Records.filter(
              x => x.is_private_rate_card == "N"
            );
            this.PrivateRatecardsList = data.Records.filter(
              x => x.is_private_rate_card == "Y"
            );
            this.PrivateRatecardsListCopy = data.Records.filter(
              x => x.is_private_rate_card == "Y"
            );
            this.RateCardListCopy = data.Records.filter(
              x => x.is_private_rate_card == "N"
            );
            this.RateCardMappingArray = [
              {
                label: "Select All",
                RateCards: data.Records.filter(
                  x => x.is_private_rate_card == "N"
                )
              }
            ];
          } else {
            // Show Message Here:
            this.$toasted.show("No Rate Cards Found for selected cinema");
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getCinemaSetting :", error);
        });
    },
    increaseRateCard(screenseatIndex) {
      let unique_id = Math.round(Math.random() * 10000);
      this.ScreenSeatDetail[screenseatIndex].rateCards.push({
        rc_name: "Select Rate Card Group",
        rcp_name: "Rate Card Group Beta",
        start_date_time: "",
        end_date_time: "",
        rate_card_id: "",
        rate_card_private_id: "",
        unique_id,
        weekDays: {
          selectAll: true,
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true
        }
      });
      // for (let seatType of this.ScreenSeatDetail) {
      //   seatType.rateCards.push({
      //     rc_name: "Select Rate Card Group",
      //     rcp_name: "Rate Card Group Beta",
      //     start_date_time: "",
      //     end_date_time: "",
      //     rate_card_id: "",
      //     rate_card_private_id: "",
      //     unique_id,
      //     weekDays: {
      //       selectAll: true,
      //       sunday: true,
      //       monday: true,
      //       tuesday: true,
      //       wednesday: true,
      //       thursday: true,
      //       friday: true,
      //       saturday: true,
      //     },
      //   });
      // }
    },
    decreaseRatecardIndex(screenseatIndex, singleRatecardIndex) {
      let singleRateCard = this.ScreenSeatDetail[screenseatIndex].rateCards[
        singleRatecardIndex
      ];
      this.ScreenSeatDetail[screenseatIndex].rateCards.splice(
        singleRatecardIndex,
        1
      );

      // for (let seatType of this.ScreenSeatDetail) {
      //   let rateCardIndex = seatType.rateCards.findIndex(
      //     (x) => x.unique_id === unique_id
      //   );

      //   seatType.rateCards.splice(rateCardIndex, 1);
      // }
    },
    onSelectRateCard: function(screenseatIndex, singleRatecardIndex, ratecard) {
      this.ScreenSeatDetail[screenseatIndex].rateCards[
        singleRatecardIndex
      ].rc_name = ratecard.rc_g_name;
      this.ScreenSeatDetail[screenseatIndex].rateCards[
        singleRatecardIndex
      ].rate_card_id = ratecard.rc_g_id;
    },
    onSelectRateCardPrivate: function(
      screenseatIndex,
      singleRatecardIndex,
      ratecard
    ) {
      this.ScreenSeatDetail[screenseatIndex].rateCards[
        singleRatecardIndex
      ].rcp_name = ratecard.rc_g_name;
      this.ScreenSeatDetail[screenseatIndex].rateCards[
        singleRatecardIndex
      ].rate_card_private_id = ratecard.rc_g_id;
    },
    onDropdownChange: function(event, type, item, mainIndex) {
      console.log({ event, type, item, mainIndex });
      // console.log("type ", type);
      if (type == "Cinema") {
        this.Screens[mainIndex].dropdownSelected = item.cine_name;
        this.Screens[mainIndex].fieldvalue = item.cine_id;
        this.getScreensList(event, type, item, mainIndex);
        this.searchCinema = "";
        this.onSearchCinema();
        this.getRatecardsList(item.cine_id);
      } else if (type === "Select Format") {
        this.Screens[mainIndex].dropdownSelected = item.mf_name;
        this.Screens[mainIndex].fieldvalue = item.mf_id;
      } else if (type === "screentype") {
        this.Screens[mainIndex].dropdownSelected = item.screen_type_name;
        this.Screens[mainIndex].fieldvalue = item.screen_type_id;
      }
    },
    resetHandler: function() {
      this.submitted = false;
      this.multiSelectedFormatsList = [];
      this.multiSelectedSoundTypeList = [];
      this.selectedScreenSizeFormat = "";

      this.Screens.map(x => {
        if (x.type === "text" || (x.type === "date") | (x.type === "number")) {
          x.fieldvalue = "";
          if (x.fieldname === "min_seats") {
            x.fieldvalue = "0";
          }
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = ""; //  x.label;
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        } else if (x.type == "file") {
          x.fieldvalue = "";
        }
      });

      this.ShowTypeArray.map(y => {
        y.value = false;
      });

      $("#starttime").val("");
      $("#endtime").val("");

      this.ScreenSeatDetail = [
        {
          seattype: "",
          selected_sst_group: "",
          sstg_id: null,
          sstg_name: "",
          seatcolor: "#dc2828",
          noofseats: "",
          order: "",
          entry_id: "",
          unique_entry_id: "",
          entry_description: "",
          screentype_description: "",
          selectedMappedRateCards: [],
          isActive: "Y",
          rateCards: [
            {
              rc_name: "Select Rate Card Group",
              rcp_name: "Rate Card Group Beta",
              start_date_time: "",
              end_date_time: "",
              rate_card_id: "",
              rate_card_private_id: "",
              weekDays: {
                selectAll: true,
                sunday: true,
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true
              }
            }
          ]
        }
      ];
    },
    handleSubmit(flag) {
      this.submitted = true;
      console.log("show types", this.ShowTypeArray);
      this.$validator.validate().then(valid => {
        if (valid) {
          console.log("valid", valid);
          let countSeats = 0;
          let errorMsg = "";
          let countSeathasZero = 0;
          this.ScreenSeatDetail.map(x => {
            countSeats += parseInt(x.noofseats);

            if (parseInt(x.noofseats) == 0) {
              countSeathasZero++;
            }

            if (x.selectedMappedRateCards.length > 0) {
              x.rateCards.map(y => {
                if (
                  !x.selectedMappedRateCards.some(
                    r => r.rc_g_id == y.rate_card_id
                  )
                ) {
                  let rateCard = this.RatecardsList.filter(
                    rc => rc.rc_g_id == y.rate_card_id
                  );
                  if (rateCard.length > 0) {
                    x.selectedMappedRateCards.push(rateCard[0]);
                  }
                }
              });
            }
          });
          this.errorCount = 0;
          this.ScreenSeatDetail.map(x => {
            if (!x.entry_id) {
              this.errorCount++;
            }

            if (!x.sstg_id) {
              this.errorCount++;
              errorMsg = "Please Select Screen Seat Type";
            }

            x.rateCards.map(y => {
              if (
                !y.rate_card_id ||
                // !y.rate_card_private_id ||
                !y.start_date_time ||
                !y.end_date_time
              ) {
                this.errorCount++;
              }

              if (this.isPrivateEnabled) {
                if (!y.rate_card_private_id) {
                  this.errorCount++;
                }
              } else {
                y.rate_card_private_id = 0;
              }
            });
          });

          if (this.errorCount > 0) {
            console.log("error count", this.errorCount);
            if (errorMsg) {
              this.$toasted.show(errorMsg);
            }
            return;
          }

          if (countSeats > this.Screens[6].fieldvalue) {
            return this.$toasted.show(
              "No of seats of seat type is greater than total No of seats."
            );
          } else if (countSeathasZero > 0) {
            return this.$toasted.show(
              "No of seats of seat type should not be 0."
            );
          } else if (countSeats < this.Screens[6].fieldvalue) {
            return this.$toasted.show(
              "No of seats of seat type is less than total No of seats."
            );
          } else if (
            parseInt(this.Screens[7].fieldvalue) >
            parseInt(this.Screens[6].fieldvalue)
          ) {
            return this.$toasted.show(
              `min seats No of seats of seat type is less than total No of Main seats.`
            );
          } else {
            let loader = this.$loading.show();
            this.btenable = true;
            // this.Screens[0]["min_seats"]=this.getMyCinemaStatusNew()=='Y'?
            let body = this.getRequestBody("POST", this.Screens, this.Methods);
            body["SeatDetails"] = this.ScreenSeatDetail;
            body["ShowTypeArray"] = this.ShowTypeArray;
            body["validityDate"] = this.validityDate;
            body["validityType"] = this.validityType;
            body.payload["has_seat_delivery"] = this.has_seat_delivery;
            body.payload["lead_time"] = `${this.leadTimeHH}:${this.leadTimeMM}`;
            if (this.multiSelectedFormatsList) {
              body.multiSelectedFormatsList = this.multiSelectedFormatsList;
            }
            if (this.multiSelectedSoundTypeList) {
              body.multiSelectedSoundTypeList = this.multiSelectedSoundTypeList;
            }
            if (this.selectedScreenSizeFormat.ssf_id) {
              body.screen_size_format_id = this.selectedScreenSizeFormat.ssf_id;
            }
            MasterService.AddScreens(body)
              .then(response => {
                this.btenable = false;
                const { data } = response;

                if (data.status) {
                  this.$toasted.show(data.message);
                  this.resetHandler();
                  if (flag) {
                    this.$router.push({
                      path: "/cinema-manager/screens"
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError)
              .finally(() => {
                setTimeout(() => loader.hide(), 1000);
              }); //message
          }
        } else {
          console.log("not valid");
        }
      });

      // let body = this.getRequestBody("POST", this.Screens, this.Methods);

      // MasterService.GlobalRequest(body)
      //   .then(response => {
      //     const { data } = response;
      //     if (data.status) {
      //       this.$toasted.show("Screen Created Successfully");
      //       this.resetHandler();
      //       if (flag) {
      //         // this.$toasted.show("Screen Created Successfully");
      //         this.$router.push({
      //           path: "/cinema-manager/screens"
      //         });
      //       }
      //     } else {
      //       this.$toasted.show(data.message);
      //     }
      //   })
      //   .catch(this._CatchError); //message
    },
    onInputFieldChange: function(event, item) {
      if (
        item &&
        (item.fieldname === "screen_no_of_rows" ||
          item.fieldname === "screen_no_of_cols")
      ) {
        let rowsObj = this.Screens.find(
          x => x.fieldname === "screen_no_of_rows"
        );
        let colsObj = this.Screens.find(
          x => x.fieldname === "screen_no_of_cols"
        );

        let rows = parseInt(rowsObj.fieldvalue);
        let cols = parseInt(colsObj.fieldvalue);

        if (!isNaN(rows) && !isNaN(cols)) {
          let total_seats = rows * cols;

          let seatObj = this.Screens.find(
            x => x.fieldname === "screen_no_of_seats"
          );
          if (seatObj) {
            seatObj.fieldvalue = total_seats;

            if (this.ScreenSeatDetail.length === 1) {
              this.ScreenSeatDetail[0].noofseats = total_seats;
            }
          }
        }
      } else if (item.fieldname === "screen_no_of_seats") {
        let seats = parseInt(item.fieldvalue);
        if (!isNaN(seats)) {
          if (this.ScreenSeatDetail.length === 1) {
            this.ScreenSeatDetail[0].noofseats = seats;
          }
        }
      }
    },
    getGlobalOptions: function() {
      let loader = this.$loading.show();

      MasterService.GetGlobalOptions()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.globalList = data.Records || [];
            this.globalListCopy = JSON.parse(JSON.stringify(this.globalList));

            let priv_cinema_status = this.globalList.filter(
              g => g.go_key == "PRIVATE_CINEMA_STATUS"
            );

            if (priv_cinema_status && priv_cinema_status.length > 0) {
              this.isPrivateEnabled = priv_cinema_status[0].go_value == "Y";
            }
            this.$forceUpdate();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    }
  }
};
</script>
<style>
.dropdown-curve-container label.shift-up {
  /*top: -14px !important;*/
}
#imagecropper .btn-clearDate {
  margin-top: -10px;
  margin-right: -10px;
  font-size: 19px;
}

.screen-box .shift-name-label {
  height: 42px;
}
.screen-box .select-color {
  width: 48px;
  height: 42px;
}

.qrcode-border-box {
  border: 2px dotted #a3a1a1;
  border-radius: 10px;
  height: 125px;
  width: 125px;
  margin: auto;
}

.screen-box {
  border: 2px solid var(--lightgrey);
  background: #e6e6f8;
  padding: 20px;
  border-radius: 08px;
}
.screen-inner {
  border: 2px solid #a1a1a4;
  border-radius: 08px;
  padding: 1rem;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemasScreenComponents/addScreens.vue